import React from 'react';
import {
    SearchBarWrapper,
    SearchInput,
    SerachButton,
    SerachIcon,
} from './components/ui-extended';
import searchIconPng from '../../images/icons/search.png';
import PropTypes from 'prop-types';

import getTexts from 'utils/localization';
const t = getTexts();

class SearchBar extends React.Component {
    constructor() {
        super();

        this.state = {
            searchText: '',
            isSearchProcessActivated: false,
        };
    }

    onSearchTextChanged = (event) => {
        this.setState({ searchText: event.target.value });
    };

    onFindClickHandler = () => {
        if (this.state.searchText.length > 3) {
            this.props.onFindHandler(this.state.searchText);
            this.setState({ isSearchProcessActivated: true });
        }
    };

    onCancelClickHandler = () => {
        this.setState({ searchText: '', isSearchProcessActivated: false });
        this.props.onCancelHandler();
    };

    render() {
        return (
            <SearchBarWrapper>
                <SerachIcon size="x05" src={searchIconPng} />
                <SearchInput
                    placeholder={t.search.placeholder}
                    value={this.state.searchText}
                    onChange={this.onSearchTextChanged}
                />{' '}
                {!this.state.isSearchProcessActivated ? (
                    <SerachButton onClick={this.onFindClickHandler}>
                        {t.search.button}
                    </SerachButton>
                ) : (
                    <SerachButton secondary onClick={this.onCancelClickHandler}>
                        {t.search.cancel}
                    </SerachButton>
                )}
            </SearchBarWrapper>
        );
    }
}

SearchBar.propTypes = {
    onFindHandler: PropTypes.func.isRequired,
    onCancelHandler: PropTypes.func.isRequired,
};

export default SearchBar;
